<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-8">
                <emblem
                    ><slot></slot>
                    <a
                        v-if="data.urls.subscription"
                        class="ml-1"
                        :href="data.urls.subscription"
                        >(Manage subscriptions)</a
                    >
                </emblem>
            </div>
            <div class="col-12 col-md-4">
                <div class="text-input search">
                    <input
                        v-model="query"
                        name="search"
                        placeholder="Search legislation"
                        class="text-input__input"
                        @keyup.enter="searchLegislations"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div
                v-for="(cardData, index) in data.items"
                :key="index"
                class="col-12 col-md-6 col-lg-4 mb-3"
            >
                <title-card :card-data="cardData" />
            </div>
            <div class="col-12 col-md-6 col-lg-4 mb-3">
                <a class="view-all__link" :href="data.urls.legislationMonitor"
                    >View all
                    <span
                        class="icon-angle-right card__bottom__button__content__icon"
                    ></span
                ></a>
            </div>
        </div>
    </div>
</template>

<script>
import emblem from '@/components/emblem';
import titleCard from '@/components/cards/title-card';

export default {
    components: {
        emblem,
        titleCard
    },

    props: {
        data: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            query: ''
        };
    },
    methods: {
        searchLegislations() {
            const legislationMonitorUrl = this.data.urls.legislationMonitor;

            this.$router.push({
                path: legislationMonitorUrl,
                query: { search: this.query }
            });
            location.reload();
        }
    }
};
</script>

<style lang="scss">
.view-all__link {
    padding: 7px 30px;
    background-color: $brand-blue;
    color: $brand-white;
    display: block;
    font-family: $font-family-brand;
    font-size: 1.2rem;
    -webkit-transition: transform 0.3s ease-out;
    transition: transform 0.3s ease-out;
    text-transform: uppercase;

    &:hover {
        color: $brand-white;
        -webkit-transform: translateY(-5px);
        transform: translateY(-5px);
    }
}
</style>
